import {Organization} from '../organization';
import {Branch} from '../branch';
import {CatalogRecord} from '../catalog-record';
import {Patron} from '../patron/patron';

export class CirculationItem {
  id: number;
  organizationId: number;
  catalogRecordId: number;
  currentBranchId?: number;
  homeBranchId?: number;
  shelfId?: number;
  dueDate?: string;
  currentBranchLocationId?: number;
  barcode?: string;
  status?: CIRCULATION_ITEM_STATUS;
  statusModified?: string;
  classification?: CLASSIFICATION;
  condition?: CONDITION;
  circulating?: boolean;
  note?: string;

  checkoutSessionId?: number;

  organization?: Organization;
  homeBranch?: Branch;
  currentBranch?: Branch;
  catalogRecord?: CatalogRecord;
  patron?: Patron;

  lastLocalAccess?: string;
}

export enum CIRCULATION_ITEM_STATUS {
  CHECKED_OUT = 'CHECKED_OUT',
  IN_TRANSFER = 'IN_TRANSFER',
  IN_LIBRARY = 'IN_LIBRARY',
  HELD = 'HELD',
  LOST = 'LOST',
  MISSING = 'MISSING',
  WITHDRAWN = 'WITHDRAWN',
  CLAIM_RETURNED = 'CLAIM_RETURNED',
  CLAIM_NEVER_HAD = 'CLAIM_NEVER_HAD',
  CLAIM_MISSING_PARTS = 'CLAIM_MISSING_PARTS',
  SHELVING = 'SHELVING',
  BINDERY = 'BINDERY',
  IN_REPAIR = 'IN_REPAIR',
  UNAVAILABLE = 'UNAVAILABLE',
  IN_PROCESS = 'IN_PROCESS',
  ON_ORDER = 'ON_ORDER',
  DAMAGED = 'DAMAGED',
}

export enum CLASSIFICATION {
  DEWEY = 'DEWEY',
  LCC = 'LCC',
}

export enum CONDITION {
  NEW = 'NEW',
  WORN = 'WORN',
  DAMAGED = 'DAMAGED',
  DESTROYED = 'DESTROYED',
}
